// extracted by mini-css-extract-plugin
export default {"infraL1":"InfraL1_infraL1__z4DVh","smallPiegraph":"InfraL1_smallPiegraph__nprFu"};